import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { authenticationReducer } from './authentication';
import { betsReducer } from './bets';
import { boxscoresReducer } from './boxscores';
import { configurationReducer } from './configuration';
import { cryptoConnectReducer } from './cryptoConnect';
import { cryptoNonceReducer } from './crypto';
import { customerReducer } from './customer';
import { eventGamesReducer } from './eventGames';
import { eventsReducer } from './events';
import { fantasyEventGamesReducer } from './fantasyEventGames';
import { fantasyEventsReducer } from './fantasyEvents';
import { friendsReducer } from './friends';
import { friendsRequestsReducer } from './friendsRequests';
import { gamesReducer } from './games';
import { lobbyContentReducer } from './lobbyContent';
import { marketCategoriesReducer } from './marketCategories';
import { marketEventsReducer } from './marketEvents';
import { marketOutcomesReducer } from './marketOutcomes';
import { marketsReducer } from './markets';
import { mycontestsReducer } from './mycontest';
import { outcomesReducer } from './outcomes';
import { provincesReducer } from './provinces';
import { selectionsReducer } from './selections';
import { teamsReducer } from './teams';
import { ticketsReducer } from './tickets';
import { transactionsReducer } from './transactions';
import { usersReducer } from './users';
import { weatherReducer } from './weather';
import { newsletterReducer } from './newsletter';
import { claimParrotTokensReducer } from './claimParrotTokens';
export const rootReducersObject = {
    authentication: authenticationReducer,
    bets: betsReducer,
    boxscores: boxscoresReducer,
    claimParrotTokens: claimParrotTokensReducer,
    configuration: configurationReducer,
    connect: cryptoConnectReducer,
    customer: customerReducer,
    nonce: cryptoNonceReducer,
    eventgames: eventGamesReducer,
    events: eventsReducer,
    fantasyEvents: fantasyEventsReducer,
    fantasyEventGames: fantasyEventGamesReducer,
    friends: friendsReducer,
    friendsRequests: friendsRequestsReducer,
    games: gamesReducer,
    lobbyContent: lobbyContentReducer,
    marketCategories: marketCategoriesReducer,
    marketEvents: marketEventsReducer,
    marketOutcomes: marketOutcomesReducer,
    markets: marketsReducer,
    mycontests: mycontestsReducer,
    newsletter: newsletterReducer,
    outcomes: outcomesReducer,
    provinces: provincesReducer,
    selections: selectionsReducer,
    teams: teamsReducer,
    tickets: ticketsReducer,
    transactions: transactionsReducer,
    users: usersReducer,
    weather: weatherReducer
};
export const rootReducer = combineReducers(rootReducersObject);
export const store = configureStore({
    reducer: rootReducer
});
